import React from 'react';
import { motion } from 'framer-motion';
import { ClipperIcon, RazorIcon, CombScissorsIcon } from './BarberIcons';
const services = [{
  icon: <CombScissorsIcon size={28} data-id="element-172" />,
  title: 'Corte Clásico',
  description: 'Corte prolijo y atemporal, adaptado a tu estilo y tipo de rostro. Terminación impecable.',
  price: '$400'
}, {
  icon: <ClipperIcon size={28} data-id="element-173" />,
  title: 'Fade / Degradé',
  description: 'Degradados perfectos, texturas y acabados precisos para un look moderno y definido.',
  price: '$500'
}, {
  icon: <RazorIcon size={28} data-id="element-174" />,
  title: 'Corte y Barba',
  description: 'El servicio completo. Corte impecable más perfilado, rebaje y diseño de barba a tu medida.',
  price: '$550'
}];
export function Services() {
  return <section className="py-24 bg-zinc-950 relative" id="servicios" data-id="element-175">
      <div className="container mx-auto px-6" data-id="element-176">
        <div className="text-center mb-16" data-id="element-177">
          <span className="block text-[11px] sm:text-xs font-display uppercase tracking-[0.35em] text-red-500 mb-4" data-id="element-178">
            La experiencia Okrim
          </span>
          <h2 className="font-display text-4xl md:text-6xl font-bold uppercase tracking-tight text-zinc-50 mb-4" data-id="element-179">
            Nuestros Servicios
          </h2>
          <p className="text-zinc-400 max-w-2xl mx-auto font-light" data-id="element-180">
            Atención al detalle y técnica profesional para garantizar resultados
            de primer nivel.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto" data-id="element-181">
          {services.map((service, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2,
          duration: 0.5
        }} className="glass-panel p-8 rounded-2xl group hover:border-red-500/50 hover:shadow-[0_0_40px_rgba(220,38,38,0.12)] hover:-translate-y-1 transition-all duration-300" data-id="element-182">
              <div className="relative w-16 h-16 mb-6" data-id="element-183">
                {/* Soft glow behind the icon */}
                <div className="absolute inset-0 rounded-2xl bg-red-600/20 blur-xl opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-184" />
                {/* Icon tile */}
                <div className="relative w-16 h-16 rounded-2xl bg-gradient-to-br from-zinc-800 to-zinc-900 ring-1 ring-inset ring-white/5 flex items-center justify-center text-red-500 shadow-inner group-hover:ring-red-500/40 group-hover:text-red-400 transition-all duration-300" data-id="element-185">
                  <motion.div whileHover={{
                rotate: -8,
                scale: 1.1
              }} transition={{
                type: 'spring',
                stiffness: 300,
                damping: 12
              }} data-id="element-186">
                    {service.icon}
                  </motion.div>
                </div>
                {/* Barber-pole accent stripe on the corner */}
                <div className="absolute -bottom-1 -right-1 w-5 h-5 rounded-full barber-stripe ring-2 ring-zinc-950 opacity-70 group-hover:opacity-100 transition-opacity" data-id="element-187" />
              </div>
              <h3 className="font-display text-2xl font-bold uppercase tracking-wide mb-3 text-zinc-100" data-id="element-188">
                {service.title}
              </h3>
              <p className="text-zinc-400 mb-6 text-sm leading-relaxed font-light" data-id="element-189">
                {service.description}
              </p>
              <div className="flex items-center justify-between mt-auto pt-4 border-t border-zinc-800/50" data-id="element-190">
                <span className="text-xs text-zinc-500 font-display uppercase tracking-[0.2em]" data-id="element-191">
                  Valor
                </span>
                <span className="font-display text-2xl font-bold text-red-400" data-id="element-192">
                  {service.price}
                </span>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="mt-12 flex justify-center" data-id="element-193">
          <div className="inline-flex items-center px-6 py-3 rounded-full border border-red-500/40 text-red-300 font-display uppercase tracking-[0.15em] text-xs sm:text-sm drop-shadow-[0_0_10px_rgba(239,68,68,0.6)]" data-id="element-194">
            <span data-id="element-195">Cejas incluidas en cualquier servicio</span>
          </div>
        </motion.div>
      </div>
    </section>;
}